export default {
  // Core
  dashboard: '/',
  compare: '/compare',
  compareDeals: '/compare/:dealids',
  pareto: '/pareto',
  paretoDeals: '/pareto/:dealids',
  portfolio: '/portfolio',
  portfolioDeals: '/portfolio/:dealids',
  authCallback: '/auth/callback',
  unauthorized: '/unauthorized',
  oops: '/oops',
  whatsnew: '/whatsnew',

  bookmark: '/bookmark',

  // Marker
  markerList: '/markers',
  markerDetail: '/markers/:id',
  markerCreate: '/markers/new',

  // Formula
  formulaList: '/formulas',
  formulaDetail: '/formulas/:id',
  formulaCreate: '/formulas/new',

  // Deal
  deals: '/deals',
  dealDetail: '/deals/:id',
  dealCreate: '/deals/new',

  // External
  help: 'https://eu001-sp.shell.com/sites/AAAAA9780/ce/SM/SitePages/Learning.aspx',
  salesforce: 'https://shell-ch.lightning.force.com/lightning/r/Report/00O4H000004zR56UAE/view?queryScope=userFolders',
  reportAnIssue:
    'https://servicenow.shell.com/sp?id=kb_article_view&sysparm_article=KB0322923',
  feedback: 'https://eu001-sp.shell.com/sites/AAAAA9780/ce/SM/SitePages/Feedback.aspx',
  pricingExcellence: 'https://pricingtoolkit.shell.com',
};
